module.exports = __webpack_public_path__ + "img/xls-icon.44930832.svg";